
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'ホーム', path: '/' },
    { name: 'ブログ', path: '/blog' },
    { name: '資料ダウンロード', path: '/document' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className={`sticky top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-sm' : 'bg-white'}`}>
      <div className="w-full px-6 lg:px-10">
        <div className="flex items-center justify-between h-16">
          {/* ロゴ */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/e6428b60f9e010c4d343b75238d76ec4/b80d6f63db625f354fc913d075307be3.png" 
                alt="ジョゼロD" 
                className="h-8"
              />
            </Link>
          </div>

          {/* デスクトップナビゲーション */}
          <nav className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 cursor-pointer ${
                  location.pathname === item.path
                    ? 'text-cyan-600 bg-cyan-50'
                    : 'text-gray-600 hover:text-cyan-500 hover:bg-gray-50'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/contact"
              className={`ml-3 bg-cyan-500 text-white px-5 py-2 rounded-md hover:bg-cyan-600 transition-colors duration-200 text-sm font-medium whitespace-nowrap cursor-pointer ${
                location.pathname === '/contact' ? 'bg-cyan-600' : ''
              }`}
            >
              お問い合わせ
            </Link>
          </nav>

          {/* モバイルメニューボタン */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-cyan-500 cursor-pointer p-2"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={isMenuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
              </div>
            </button>
          </div>
        </div>

        {/* モバイルメニュー */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <div className="flex flex-col space-y-1">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-4 py-3 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                    location.pathname === item.path
                      ? 'text-cyan-600 bg-cyan-50'
                      : 'text-gray-600 hover:text-cyan-500 hover:bg-gray-50'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <Link
                to="/contact"
                className="mt-2 bg-cyan-500 text-white px-4 py-3 rounded-md text-sm font-medium text-center cursor-pointer hover:bg-cyan-600 transition-colors"
              >
                お問い合わせ
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
